import React from 'react';
import styled from 'styled-components';
import { Module } from '../Module';
import { GridRow } from '../GridRow';
import { ImageWrap, TextWrap } from './partials';
var TextImage = function TextImage(props) {
  return React.createElement(Module, {
    noMargin: props.noMargin || true,
    className: props.className
  }, React.createElement(GridRow, {
    align: props.align,
    reverse: props.imageAlign === 'right'
  }, React.createElement(ImageWrap, {
    cols: props.imageCols,
    offset: props.imageOffset,
    mobilePadding: props.mobileImagePadding,
    padding: props.imagePadding,
    disableStackMargin: props.disableStackMargin,
    hideBelowDesktop: props.hideImageBelowDesktop
  }, React.createElement("img", {
    src: props.image
  })), React.createElement(TextWrap, {
    cols: props.textCols,
    offset: props.textOffset,
    padding: props.textPadding,
    disableStackMargin: props.disableStackMargin
  }, props.children)));
};
TextImage.defaultProps = {
  align: 'top',
  imageAlign: 'left',
  imageCols: 6,
  textCols: 6,
  textPadding: 'auto',
  imageOffset: 0,
  textOffset: 0,
  imagePadding: 'none',
  disableStackMargin: false
};
export default styled(TextImage).withConfig({
  displayName: "TextImage",
  componentId: "sc-mv9da9-0"
})(["button{margin-top:56px;}"]);